import Http from '@pc/components/libs/request/1.0/index';

export default {
	// 查询规则列表
    getRuleDynamicsList (opts = {}) {
        return Http.post( '/route0014/platform/rule/getRuleDynamics.json', opts)
    },

	// 查询规则详情
    getRuleDynamicsDetail (opts = {}) {
        return Http.post( '/route0014/platform/rule/getRuleDynamicDetail.json', opts)
    }
}
